export default __webpack_public_path__ + "static/media/tab_8.ec338bbb.svg";